<template>
  <div class="quiz">
    <div class="total_point">
      <div class="point_element">
        <div class="is-half ele-left" v-if="quizzes.questions">
          <p>
            <span class="score">{{ score }}</span>
            /
            <span class="total">{{ quizzes.questions.length }}</span>
          </p>
          <p class="note">{{ $t("ONLINE_TRAINING.QUIZ.NOTE") }}</p>
        </div>
        <div class="is-half ele-right">
          <b-button
            v-if="submitButtonVisible"
            @click="
              answers.questions.length === quizzes.questions.length
                ? submitAllAnswer()
                : ''
            "
            :class="
              answers &&
              answers.questions &&
              answers.questions.length === quizzes.questions.length
                ? 'submit-quiz complete'
                : 'submit-quiz'
            "
            type="is-light"
          >{{ $t("ONLINE_TRAINING.QUIZ.BUTTON_CONFIRM") }}</b-button>
          <div v-else class="limited-warning">
            <img :src="`${$baseUrl}/img/online-training/alert-white.svg`" alt="alert" width="20" height="20" />
            <p>{{ warningMessage }}</p>
          </div>
        </div>
      </div>
    </div>
    <section class="template-quiz">
      <ul v-for="(question, index) in quizzes.questions" :key="question._id">
        <DetailQuiz
          :question="question"
          :index="index"
          :disabled="
            list_answer[0].questions.findIndex(e => e._id === question._id) !==
              -1
          "
          @onSubmit="handleSubmit"
        />
      </ul>
    </section>
  </div>
</template>
<script>
import DetailQuiz from "./DetailQuiz";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    DetailQuiz
  },
  props: {
    course_id: {
      type: Number
    }
  },

  computed: {
    ...mapGetters([
      "course",
      "answers",
      "getSubmitStatus",
      "supplierToken",
      // "getTimesSubmitted"
    ]),
    ...mapState({
      courses: state => state.course.courses,
      dataQuiz: state => state.course.dataQuiz,
      score: state => state.course.score,
      quizzes: state => state.course.quizzes
    }),
    submitButtonVisible() {
      return this.supplierToken
    },
    warningMessage() {
      if (!this.supplierToken) {
        return this.$t("ONLINE_TRAINING.MESSAGE.FEATURE_NOT_AVAILABLE");
      }

      return this.$t("ONLINE_TRAINING.MESSAGE.LIMITED_SUBMIT");
    }
  },

  data() {
    // const courseId = this.course && this.course._id;
    return {
      list_answer: [
        {
          course_id: this.course_id,
          questions: []
        }
      ],
      // submitted: 3 // default time of submiting is 3 times each token
    };
  },

  methods: {
    handleSubmit(question) {
      let formData = {
        _id: question._id,
        answers: []
      };

      formData.answers = question.answers.map(a => {
        return {
          _id: a._id,
          selected: a.selected !== undefined ? a.selected : false
        };
      });

      this.list_answer[0].questions.push(formData);
      this.$store.dispatch("addDriverAnswer", this.list_answer[0]);
    },

    submitAllAnswer() {
      this.$store.dispatch("submitAnswers", this.supplierToken);
      this.$gtag('event',this.$trackingEvents.EVENTS.SUBMIT_COURSE, {'event_category' : this.$route.path})
    }
  },

  watch: {
    getSubmitStatus(newVal, oldVal) {
      if (oldVal === "loading") {
        if (newVal === "success") {

          // TODO: support old online-training link
          if (this.$route.name === 'course-v1') {
            this.$router.push({
              name: "result-v1"
            });
          } else {
            this.$router.push({
              name: "result",
              params: { slug: this.$route.params.slug }
            });
          }          
        } else if (newVal === "error") {
          console.log("submit error");
        }
      }
    }
  }
};
</script>
<style lang="scss">
@media screen and (min-width: 1024px) {
  .quiz .total_point {
    position: absolute !important;
    left: 0;
  }
}
.quiz {
  background-color: white;
  position: relative;

  label {
    width: 100%;
  }

  .total_point {
    position: fixed;
    z-index: 100;
    width: 100%;
    height: 60px;
    bottom: 0;
    left: 0;
    background-color: #142246;
    margin: 0;

    .point_element {
      height: 100%;
      color: white;
      display: flex;
      justify-content: space-between;

      .ele-right {
        width: 50%;
        button.submit-quiz {
          width: 160px;
          height: 40px;
          margin: 10px;
          border-radius: 2px;
          background: #bcbcbc;
          color: white;
          font-size: 14px;
          float: right;
        }

        button.submit-quiz.complete {
          background: #ff8200;
        }

        .limited-warning {
          display: flex;
          margin: 0 auto;
          align-items: center;
          padding: 10px;
          height: 100%;
          float: right;
          p {
            font-size: 13px;
          }
          img {
            margin: 0 10px;
          }
        }
      }

      .ele-left {
        margin: 0 16px;
        .score {
          font-size: 24px;
          color: #1dc05e;
          font-weight: 500;
        }
        .note {
          font-size: 10px;
        }
      }
    }
  }

  .template-quiz {
    padding-bottom: 60px;
  }
}

.notices.is-bottom {
  .notification {
    position: absolute;
    bottom: 70px;
    border-radius: 47px;
    font-weight: 500;
    padding: 10px 20px;
    width: 200px;
    .media {
      .media-content {
        .text {
          text-align: center;
          font-weight: 500;
        }
      }
    }
    .delete {
      display: none;
    }
  }
}
</style>
